import React from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { InvestmentTypeEnum } from "@rentablo/api/apiv1";
import WarningIcon from "@icons/myicons/warning-circle.svg?react";
import { Tooltip } from "@rentablo/components";
import { shouldIgnoreFieldError } from "@features/csvDrop/shouldIgnoreFieldError";

type Props = {
  name: string;
  assetType: InvestmentTypeEnum;
  error?: string;
};

export const FieldLabel = ({ name, assetType, error }: Props) => {
  const { t } = useTranslation();
  const fieldLabel =
    name === "number_of_lots" && assetType === InvestmentTypeEnum._31_BOND
      ? `${name}_bond`
      : name;

  const shouldHideError = shouldIgnoreFieldError(name);

  return (
    <Box display="flex" alignItems="center" gap={2}>
      {t(`csvImport.parsingResults.${fieldLabel}`)}
      {error && !shouldHideError && (
        <Tooltip
          text={t("csvImport.parsingResults.error", {
            name: t(`csvImport.parsingResults.${name}`),
          })}
        >
          <Box display="flex" alignItems="center" color="warning.main">
            <WarningIcon />
          </Box>
        </Tooltip>
      )}
    </Box>
  );
};
